module.exports = __webpack_public_path__ + "img/ar01.36b1eb92.jpg";